<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('invoice.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <!-- <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'invoice-create' })"
            >{{ $t('add_new') }}</ts-button
          > -->
          <a-range-picker
              style="width: 280px;"
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
          >
            <template slot="renderExtraFooter"></template>
          </a-range-picker>
          <div></div>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('invoice.search')"
              style="width: 350px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('invoice.branch') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="model.branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>              
              <div class="form-group">
                <label>{{ $t('preInvoice.subProgram') }}</label>
                <a-select
                    style="width: 257px"
                    v-model="model.acps_id"
                    :options="subprograms"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                </a-select>
              </div>
              <div class="form-group">
                <label>{{ $t('preInvoice.grade') }}</label>
                <a-select
                    style="width: 257px"
                    v-model="model.grade_id"
                    :options="grades"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                </a-select>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <ts-checkbox v-model="model.is_deleted"
                    >Voided</ts-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <p>
                <i class="fas fa-sticky-note"></i>
                {{
                  record.inv_number
                }}
              </p>
              <span
                v-tooltip="$t('invoice.invoiceDate')"
                class="ts-text-orange-500 ts-font-semibold"
              >
                <i class="fas fa-calendar-alt"></i>
                {{ record.inv_date }}
              </span>
            </td>
            <td class="ts-whitespace-no-wrap">
              <p
                class="ts-font-semibold ts-text-blue-600"
                v-tooltip="$t('invoice.studentName')"
              >
                <i class="fas fa-user-graduate"></i>
                {{ record.full_name_en }}
              </p>
              <p v-tooltip="$t('invoice.studentId')">
                <i class="fas fa-id-card-alt"></i>
                {{ record.card_number }}
              </p>
              <p v-tooltip="$t('invoice.sex')">
                <i class="fas fa-transgender-alt"></i>
                {{ record.gender }}
              </p>
              <p
                v-tooltip="$t('invoice.phoneNumber')"
                class="ts-text-blue-500"
                v-if="record.phone"
              >
                <i class="fas fa-mobile"></i>
                {{ record.phone }}
              </p>
              <p v-if="record.is_new_student">
                <span
                  class="ts-bg-red-600 ts-px-1 ts-rounded-lg ts-text-white ts-text-xs"
                  >{{ $t('invoice.new') }}</span
                >
              </p>
              <p v-else>
                <span
                  class="ts-bg-gray-600 ts-px-1 ts-rounded-lg ts-text-white ts-text-xs"
                  >{{ $t('invoice.old') }}</span
                >
              </p>
            </td>
            <td class="ts-whitespace-no-wrap">
              <p>
                {{ record.grade.grade_name_foreign }}
              </p>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.year }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.semester }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              $ {{ record.total_amount }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              $ {{ record.amount_paid }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              $ {{ record.amount_due }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <span
                class="ts-bg-orange-600 ts-text-white ts-font-semibold ts-rounded-lg ts-px-2"
                v-if="record.next_payment_date"
              >
                {{ record.next_payment_date }}
              </span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span v-if="!record.is_paid" class="label label-danger"
                >Unpaid</span
              >
              <span v-else class="label label-success">Paid</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.user
                  ? record.user.employee
                    ? record.user.employee.name_en
                    : null
                  : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <div v-if="record.remark ? record.remark.length < 25 : true">
                {{ record.remark }}
              </div>
              <div v-tooltip="record.remark" v-else>
                {{ record.remark.substring(0, 25) + '...' }}
              </div>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                v-tooltip="$t('tooltip.show')"
                class="mr-2 text-primary"
                @click.prevent="show(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                v-show="record.is_deleted == 0"
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <pdf-preview
        v-model="pdf_view"
        :invoice-id="invoiceId"
        @cancel="value => (pdf_view = value)"
      />
    </ts-card>
  </div>
</template>
<script>

class Pagination {
	constructor(paging = {}) {
		this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
		this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
		this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
		this.total = paging.total ? parseInt(paging.total) : 0
		this.from = this.perPage * (this.currentPage - 1) + 1
		this.to = this.perPage * this.currentPage
	}
}

import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { PdfPreview, Reason } from './components'
import moment from 'moment'

export default {
  name: 'invoice',
  components: {
    PdfPreview
  },
  data () {
    return {
      search: '',
      pdf_view: false,
      resources: [],
      branchs: [],
      subprograms: [],
      grades: [],
      loading: false,
      invoiceId: 0,
      pagination: new Pagination(),
      visible: false,
      model: {
        is_deleted: false,
        branch_id: undefined,
        acps_id: undefined,
        grade_id: undefined,
        void_reason: null
      },
      rangeDate: [moment(), moment()]
    }
  },
  created() {
    this.fetchData({
      page: 1, 
      perPage: 15,
      is_deleted: false,
      date_from: moment().format('DD-MM-YYYY'),
      date_to: moment().format('DD-MM-YYYY')
    })
    this.fetchResource()
  },
  computed: {
    columns() {
      return [
        { name: this.$t('invoice.branch') },
        { name: this.$t('invoice.invoice') },
        { name: this.$t('invoice.student') },
        { name: this.$t('invoice.grade') },
        { name: this.$t('invoice.year') },
        { name: this.$t('invoice.semester') },
        { name: this.$t('invoice.totalAmount'), style: 'text-align:center' },
        { name: this.$t('invoice.paidAmount'), style: 'text-align:center' },
        { name: this.$t('invoice.dueAmount'), style: 'text-align:center' },
        { name: this.$t('invoice.nextPaymentDate') },
        { name: this.$t('invoice.status'), style: 'text-align:center' },
        { name: this.$t('invoice.cashier') },
        { name: this.$t('invoice.remark'), style: 'width:27%' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    ...mapActions('officailReceiptModule', ['onDeleteRecord', 'onGetSubprogram', 'onGetGrade']),
    fetchData (attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'officailReceiptModule/onFetch',
          Object.assign({}, attributes)
        )
        .then(response => {
          this.resources = response.data.data
          this.RECEIVE_RESOURCES(response.data)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.response.data.message)
        })
    },
    fetchResource(){
      this.$store
          .dispatch('user/getBranch', {
            filter: {
              user_branches: true
            }
          })
          .then(response => {
            this.branchs = response.data.map(el => ({
              value: el.branch_id,
              label: el.branch_name_en
            }))
          })

      this.onGetSubprogram()
        .then(response => {
            this.subprograms = response.data.data
            .map(el => ({
              value: el.acps_id,
              label: el.acps_name_foreign
            }))
      })

      this.onGetGrade()
        .then(response => {
            this.grades = response.data.data
            .map(el => ({
              value: el.grade_id,
              label: el.grade_name_foreign + (el.level ? '|' + el.level.level_name_foreign : '')
            }))
      })
    },
    RECEIVE_RESOURCES(records) {
			const { data, ...meta } = records
			this.resources = data
			this.$nextTick(() => {
				this.pagination.currentPage = meta.meta.current_page
				this.pagination.lastPage = meta.meta.last_page
				this.pagination.perPage = meta.meta.per_page
				this.pagination.total = meta.meta.total
				this.pagination.from = meta.meta.from
				this.pagination.to = meta.meta.to
			})
		},
    dateRangeChange(dateRange) {
      this.$store.commit(
        'officailReceiptModule/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'officailReceiptModule/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData({
        search: this.search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        is_deleted: this.model.is_deleted
      })
    },
    deleteRecord(record) {
      this.model.void_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('invoice.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.onDeleteRecord({
            id: record.inv_id,
            void_reason: this.model.void_reason
          })
            .then((response) => {
              this.$toasted.success(response.data.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.response.data.message)
              this.errors = new Errors(error.response.data.errors)
              return Promise.reject(error.response.data)
            })
        },
        onCancel() {}
      })
    },
    show(record) {
      this.$router.push({
        name: 'invoice-show',
        params: { 
          id: record.inv_id,
          data: record
        }
      })
    },
    pdfView(record) {
      this.invoiceId = record.inv_id
      this.pdf_view = true
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ 
        search, 
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.branch_id': debounce(function (value) {
      this.fetchData({ 
        branch_id: value,
        search: this.search, 
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.acps_id': debounce(function (value) {
      this.fetchData({ 
        acps_id: value,
        search: this.search, 
        branch_id: this.model.branch_id,
        grade_id: this.model.grade_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.grade_id': debounce(function (value) {
      this.fetchData({ 
        grade_id: value,
        search: this.search, 
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.is_deleted': debounce(function (value) {
      this.fetchData({ 
        is_deleted: value,
        grade_id: this.model.grade_id,
        search: this.search, 
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id
      })
    }, 500)
  }
}
</script>
